import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';

// §28.1.2 client funnel: full-page fallback with the eventId behind Details.
export function RootBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();
  const eventId = Sentry.captureException(error);

  useEffect(() => {
    // no-op effect keeps this a client component boundary for future data hooks
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-bg px-6 text-center text-ink">
      <div className="max-w-sm">
        <h1 className="font-display text-2xl font-bold">{t('errorBoundary.title')}</h1>
        <p className="mt-2 text-sm text-muted">{t('errorBoundary.description')}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 bg-accent px-5 py-2 text-sm font-semibold text-on-accent"
        >
          {t('errorBoundary.reload')}
        </button>
        <details className="mt-4 text-xs text-muted">
          <summary className="cursor-pointer">{t('errorBoundary.details')}</summary>
          <p className="mt-1 font-mono">{eventId}</p>
        </details>
      </div>
    </div>
  );
}
